module.exports = __webpack_public_path__ + "static/media/services_children.8e1507d6.jpg";